export const shouldSkipFetchTicket = (ticketId) =>
    !ticketId || (ticketId && ticketId === 'new')
